function cov_gr733dt2() {
  var path = "/app/src/types/country-name.ts";
  var hash = "f32795f4eab421fa642c0ed9049a19dadce23819";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/types/country-name.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 27
        },
        end: {
          line: 7,
          column: 10
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f32795f4eab421fa642c0ed9049a19dadce23819"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_gr733dt2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_gr733dt2();
export var CountryName = (cov_gr733dt2().s[0]++, {
  saudi: 'saudi',
  emirates: 'emirates',
  kuwait: 'kuwait',
  bahrain: 'bahrain',
  qatar: 'qatar'
});